import { Injectable } from '@angular/core';


export class CookieService {
	private cookieAppName: string = 'hackajob_app';
	private cookieOptions = {
		path: '/',
		expires: new Date(new Date().setFullYear(new Date().getFullYear() + 9)),
		domain: process.env.COOKIE_DOMAIN,
		samesite: 'lax',
		secure: process.env.COOKIE_SECURE
	};

	public get(cookieName?: string) {
		if (cookieName) {
			return this.getCookie(cookieName);
		}
		const cookie = this.getCookie(this.cookieAppName);
		if (typeof cookie === 'undefined' || !cookie.user_type || !cookie.token || !cookie.client) {
			return false;
		}
		return cookie;
	}

	public set(cookieObj: any, cookieName?: string, expireDate?: Date) {
		cookieName = cookieName ? cookieName : this.cookieAppName;
		if (expireDate) {
			this.cookieOptions.expires = expireDate;
		}
		if (this.cookieOptions.secure) {
			// tslint:disable-next-line:max-line-length
			document.cookie = `${cookieName}=${encodeURIComponent(JSON.stringify(cookieObj))};expires=${this.cookieOptions.expires};path=${this.cookieOptions.path};domain=${this.cookieOptions.domain};samesite=${this.cookieOptions.samesite};secure`;
			return;
		}
		// tslint:disable-next-line:max-line-length
		document.cookie = `${cookieName}=${encodeURIComponent(JSON.stringify(cookieObj))};expires=${this.cookieOptions.expires};path=${this.cookieOptions.path};domain=${this.cookieOptions.domain};samesite=${this.cookieOptions.samesite}`;
	}

	public deleteAppCookie(): void {
		if (this.cookieOptions.secure) {
			// tslint:disable-next-line:max-line-length
			document.cookie = `${this.cookieAppName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${this.cookieOptions.path};domain=${this.cookieOptions.domain};samesite=${this.cookieOptions.samesite};secure`;
			return;
		}
		// tslint:disable-next-line:max-line-length
		document.cookie = `${this.cookieAppName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${this.cookieOptions.path};domain=${this.cookieOptions.domain};samesite=${this.cookieOptions.samesite}`;
	}

	private getCookie(cookieName: string) {
		const cookie = document.cookie.split('; ').find((row) => row.startsWith(`${cookieName}=`));
		if (cookie) {
			return JSON.parse(decodeURIComponent(cookie.split('=')[1]));
		}
		return cookie;
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/providers/cookie.service.ts